import {
  isEmpty,
  get,
} from '@/utils/lodash';

export default {
  isShoppingCartEmpty(state) {
    return isEmpty(get(state.shoppingCart, 'products'));
  },
  getLocalCartProducts(state) {
    return isEmpty(get(state.shoppingCart, 'guestCart'))
  }

};
